/**
 * @author vishwadeep.kapoor
 * @description file contains the default export of both utils file
 */
import * as constants from './constants';
import * as utils from './commonUtils';
import validations from './validations';
import eventTracking from './analytics/googleEventTracking';
import fbTracker from './analytics/fbEventTracker';
export { SEO_TAGS as metaTags } from './analytics/seoTags';
export { default as validationRules } from './validationRules';

export {
  constants,
  utils,
  validations,
  fbTracker,
  eventTracking,
};



// WEBPACK FOOTER //
// client/devUtils/index.js